import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failedMethods = ["Los 'Pull-Ups' son solo pañales con otro nombre y confunden la memoria sensorial del niño.", "Tratar de entrenarlo 'poco a poco' solo alarga la agonía y crea mensajes mixtos.", "Preguntar '¿Quieres ir al baño?' le da el control a un niño que siempre elegirá seguir jugando.", "El miedo al accidente en la alfombra te hace ponerle el pañal 'por si acaso', rompiendo el aprendizaje.", 'Falta de un plan de batalla real para el lunes por la mañana en la escuela.'];
export function FailedMethodsSection() {
  return <section className="bg-white py-12 px-4" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-18">
            Lo que ya intentaste (y por qué no funcionó)
          </h2>
          <div className="w-24 h-1 bg-coral mx-auto rounded-full" data-id="element-19"></div>
        </motion.div>

        <div className="grid gap-4" data-id="element-20">
          {failedMethods.map((method, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-5 bg-cream rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-21">
              <XCircle className="text-red-400 shrink-0 mt-1 mr-3" size={24} data-id="element-22" />
              <p className="text-lg text-gray-700 font-medium" data-id="element-23">{method}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}